import React, { useEffect } from 'react';
import DemoHomeworkScheduleDetail from '../demo/DemoHomeworkScheduleDetail';

const StandardStudents = ({ user, onLogout }) => {
  useEffect(() => {
    const uid = user?.uid;
    if (!uid) return;
    localStorage.setItem(`studentProfileMode_${uid}`, 'default');
  }, [user?.uid]);

  return <DemoHomeworkScheduleDetail user={user} onLogout={onLogout} routeNamespace="standard" />;
};

export default StandardStudents;
